<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">免费进入</p>
      <div class="content-input">
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
<!--        <div class="content-input-item">-->
<!--          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)"/>-->
<!--        </div>-->
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
<!--          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
          <el-input type="search" v-model="searchPhone" placeholder="请输入内容" :maxlength="11" style="margin-right: 8px; width: 16em">
            <template #prefix>
              <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
            </template>
          </el-input>
          <el-button type="primary" @click="openDialog()">操作</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            border
        >
<!--          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
          <el-table-column property="phone" label="手机号" v-if="checkColList.indexOf('手机号') > -1" class-name="cursor"/>
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
          <el-table-column property="createTime" label="备注" v-if="checkColList.indexOf('备注') > -1" class-name="cursor">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange_30_1'
import BtnGroup from '../../components/BtnGroup'
import {
  getFreeUserEnterPageList,
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import enterFreeList from "@/views/user/components/enterFreeList";
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import UserLog from "@/components/UserLog/UserLog";

export default {
  name: "EnterFree",
  components: { DatePickerRange, BtnGroup, UserLog },
  data() {
    return {

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,


      //搜索
      searchType: '',
      searchValue: '',

      searchPhone: '',

      //刷新组
      colList: ['手机号', '创建时间', '备注'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchRejectLoading: false,
      updateReLoading: false,
      updateNewLoading: false,

      idArray: [],

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },


    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.talentStatus = 2;
      this.selectType = 0;
      this.type = 0;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },



    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getFreeUserEnterPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '备注') {
        Dialog.open({
          title: '备注',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      //更新用户日志
      if(column.label == '手机号') {
        Dialog.open({
          title: '用户进入渠道分析',
          component: enterFreeList,
          data: {
            userId: row.userId,
            width: '1200px'
          }
        })
      }

    },


    //搜索
    openDialog() {
      // console.log(e)
      Dialog.open({
        title: '用户进入渠道分析',
        component: enterFreeList,
        data: {
          phone: this.searchPhone,
          width: '1200px'
        }
      })
    },




  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
